// Libs
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
import { Loading } from '~/components/common';
import { ColumnCheckList } from '~/components/module/checklist';
// Others
import { jobActions } from '~/thunks/job/jobSlice';
import { IChecklist } from '~/utils/interface/checklist';
import { getDetailJob } from '~/thunks/job/jobThunk';
import { EMPTY_STRING } from '~/utils/constants/common';
import { useAppDispatch, useAppSelector } from '~/utils/redux/hooks';
import { TypeJobDetailEnum } from '~/utils/enum/common';
import { IParamQueryJobDetail } from '~/utils/interface/jobs';
// Styles, images, icons
import styles from './CheckListJobTab.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const CheckListJobTab = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/jobs', 'common/base']);
  const dispatch = useAppDispatch();
  const { id: jobId } = useParams();
  //#endregion Declare Hook

  //#region Selector
  const { isRefreshJobList } = useAppSelector((state) => state.job);
  //#endregion Selector

  //#region Declare State
  const [dataChecklist, setDataChecklist] = useState<IChecklist[]>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [paramObject] = useState<IParamQueryJobDetail>({
    jobId: jobId || EMPTY_STRING,
    type: TypeJobDetailEnum.CHECKLIST,
  });
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    if (!jobId) return;

    handleGetListChecklist(paramObject);
  }, [jobId]);

  useEffect(() => {
    if (!isRefreshJobList) return;

    handleGetListChecklist(paramObject);

    dispatch(jobActions.setRefreshJobList(false));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRefreshJobList]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleGetListChecklist = (params: IParamQueryJobDetail) => {
    setIsLoading(true);

    dispatch(getDetailJob(params))
      .unwrap()
      .then((res) => {
        if (!res?.data) return;

        if ('checklists' in res.data) {
          const checklistData: IChecklist[] = res.data.checklists.map((item) => ({
            title: item.name,
            ...item,
          }));

          setDataChecklist(checklistData);
        }
      })
      .catch((_error) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };
  //#endregion Handle Function

  return (
    <Stack id='checkListJobTabComponent' className={cx('container')}>
      {dataChecklist && dataChecklist.length > 0 ? (
        dataChecklist.map((item, index) => {
          return <ColumnCheckList checkListData={item} key={index} isDeleteItem />;
        })
      ) : (
        <Typography align='center' className={cx('noData')}>
          {t('common_no_data_available', { ns: 'common/base' })}
        </Typography>
      )}

      {isLoading && <Loading />}
    </Stack>
  );
};

export default CheckListJobTab;
